import { Language } from "../languages/labels/language.labels"
import { extractBase64 } from "./extract.base.64.script"

export function uploadedUrl(lang: Language, url: string): {value: {name: string, size: number, type: string, view: string, file: any}, valid: {file: boolean, message: string}} {
  let value = {name: (url.split('/').pop() || url).replace(/\.[^/.]+$/, ''), size: url.length, type: (url.split('.').pop() || '').toLowerCase(), view: url, file: url}
  let valid = {file: true, message: lang.labels.valid}
  return {value: value, valid: valid}
}

export async function uploadImg(lang: Language, archive: any): Promise<{value: {name: string, size: number, type: string, view: string, file: any}, valid: {file: boolean, message: string}}> {
  let archiveValue = {name: archive.name, size: archive.size, type: archive.type, view: '', file: archive}
  let archiveValid = {file: true, message: lang.labels.valid}
  let archiveType: string[] = ['image/png', 'image/jpeg', 'image/jpg']
  let archiveSize: number = 1048576

  if (!(archiveType === undefined || (archiveType && archiveType.includes(archive.type)))) {
    archiveValid = {file: false, message: lang.labels.invalidFileType}
  } else if (!((archiveSize !== 0 && archive.size <= archiveSize) || archiveSize === 0)) {
    archiveValid = {file: false, message: lang.labels.fileSizeNotAllowed}
  } else {
    archiveValue.size = Number(Math.max((archive.size / archiveSize), 0.01).toFixed(2))
    await extractBase64(archive).then( (pdf: any) => {
      archiveValue.view = pdf.base
    })
  }

  return {value: archiveValue, valid: archiveValid}
}

export async function uploadPdf(lang: Language, archive: any): Promise<{value: {name: string, size: number, type: string, view: string, file: any}, valid: {file: boolean, message: string}}> {
    let archiveValue = {name: archive.name, size: archive.size, type: archive.type, view: '', file: archive}
    let archiveValid = {file: true, message: lang.labels.valid}
    let archiveType: string[] = ['application/pdf']
    let archiveSize: number = 10485760

    if (!(archiveType === undefined || (archiveType && archiveType.includes(archive.type)))) {
      archiveValid = {file: false, message: lang.labels.fileInDifferentFormatPdf}
    } else if (!((archiveSize !== 0 && archive.size <= archiveSize) || archiveSize === 0)) {
      archiveValid = {file: false, message: lang.labels.fileIsTooBig}
    } else {
      archiveValue.size = Number(Math.max((archive.size / archiveSize), 0.01).toFixed(2))
      await extractBase64(archive).then( (pdf: any) => {
        archiveValue.view = pdf.base
      })
    }

    return {value: archiveValue, valid: archiveValid}
}

export function removeUploadedFile(): {value: {name: string, size: number, type: string, view: string, file: any}, valid: {file: boolean, message: string}} {
  return {value: {name: '', size: 0, type: '', view: '', file: null}, valid: {file: true, message: ''}}
}

export function errorUploadedMessage(lang: Language, list_valid: {file: boolean, message: string}[]): string {
  let errors: string[] = list_valid.filter((item) => (!item.file)).map((item) => (item.message))
  let fileInDifferentFormatPdf: boolean = errors.includes(lang.labels.fileInDifferentFormatPdf)
  let fileIsTooBig: boolean = errors.includes(lang.labels.fileIsTooBig)

  if (fileInDifferentFormatPdf && fileIsTooBig) {
    return lang.labels.someFilesIncorrectlyFormattedAndTooLarge
  }
  if (fileInDifferentFormatPdf) {
    return lang.labels.someFilesIncorrectlyFormatted
  }
  if (fileIsTooBig) {
    return lang.labels.someFilesTooLarge
  }
  if (errors.length > 0) {
    return lang.labels.undefined
  }

  return ""
}